import styled from 'styled-components';

export const ArticleViewContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  flex: 1;
  background-color: white;
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px;
    display: flex;
    justify-content: center;
  }

  .article-container {
    display: grid;
    gap: 20px;
    width: 60%;
    margin-right: 6%;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      gap: 16px;
      width: 100%;
      margin-right: 0;
      align-items: start;
    }

    table {
      width: auto;
    }
  }

  .article-container-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: 0;
      gap: 12px;
    }
  }

  .article-container-header-link-back {
    transform: rotate(90deg);
  }

  .article-container-header-title {
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    font-size: 14px;
    line-height: 2.4;
    color: ${(props) => props.theme.colors['terra-cotta']};

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 12px;
    }
  }

  .article-container-content {
    @media (min-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-left: 50px;
    }
  }

  .article-container-title {
    display: grid;
    gap: 10px;
    margin-bottom: 20px;

    @media (min-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-bottom: 16px;
    }

    h1 {
      font-family: ${(props) => props.theme.fonts.silkserif_black};
      font-size: 28px;
      line-height: 0.96;
      color: ${(props) => props.theme.colors.dark};
    }
  }

  .articleIntroductionText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    line-height: 1.56;
    color: #4a4a4a;
    margin-top: 70px;
  }

  .articleIntroductionText::first-letter {
    font-family: ${(props) => props.theme.fonts.silkserif_bold};
    font-size: 90px;
    line-height: 70px;
    margin-top: 12px;
    margin-right: 10px;
    color: #4a4a4a;
    float: left;
  }

  .article-container-body {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: normal;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    line-height: 1.56;
    letter-spacing: normal;
    color: #4a4a4a;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-bottom: 130px; // for see under buttons actions on aboslute position
    }

    p {
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      line-height: 24px;
      color: #4a4a4a;
      text-align: justify;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 8px;
      margin: 10px 0;
    }

    h1 {
      font-family: ${(props) => props.theme.fonts.silkserif_black};
      font-size: 50px;
      line-height: 1.2;
      color: #4a4a4a;
      justify-self: center;
      margin-top: 30px;
      margin-bottom: 30px;
      text-align: center;
    }
  }

  .article-side-menu {
    display: flex;
    flex-direction: column;
    width: 260px;
    gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      gap: 16px;
    }
  }

  .tagListContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    flex-wrap: wrap;
    gap: 10px;

    > div {
      margin: 0;
      height: 30px;
      white-space: nowrap;
      width: initial;
      font-weight: 600;
    }

    .tag {
      width: initial !important;
    }
  }

  .article-side-menu-item-label {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: #1f2b37;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .article-side-menu-separator {
    width: 100%;
    height: 1px;
    background-color: rgba(43, 61, 84, 1);
    border-radius: 4px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: none;
    }
  }

  .article-footer-menu-actions {
    display: none;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      position: fixed;
      bottom: 25px;
      width: calc(100vw - 32px);
      display: grid;
      gap: 10px;
    }

    .action-button-label {
      font-size: 16px;
      align-items: center;

      @media (max-width: ${(props) =>
          props.theme.devices.isTablet ? '0px' : '845px'}) {
        font-size: 16px;
      }
    }

    .action-button-label.actions {
      margin-right: 20px;
    }
  }

  .action-button-modal {
    padding: 16px;
  }

  .actions-button {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: calc(100vw - 32px);
      height: 45px;
      border-radius: 24px;
      font-weight: 400;
      background-color: rgb(43 61 84);
    }
  }

  .article-market-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 45px;
    border-radius: 4px;
    background-color: #ebecee;
    padding: 0 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      height: auto;
      padding: 0;
      background-color: transparent;
    }
  }

  .socialLinkContainer {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    > *:not(:last-child) {
      margin-right: 10px;
    }
  }

  .socialLink {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
    min-height: 18px;
    min-width: 18px;
    height: 18px;
    color: white;
    background-color: #9b9b9b;
    border-radius: 50%;
  }

  .instagram {
    background-color: white !important;
  }

  .likesContainer {
    display: flex;
    width: 100%;

    flex-direction: row;
    align-items: center;
    justify-content: center;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      min-height: 33px;
      min-width: 33px;
      height: 33px;
      width: 33px;
      color: white;
      background-color: ${(props) => props.theme.colors['terra-cotta']};
      border-radius: 50%;
    }

    > div:hover {
      cursor: pointer;
    }

    > div:not(:last-child) {
      margin-right: 10px;
    }
  }

  .likeContainer {
    background-color: #1f2b37 !important;
  }

  .addTag:hover {
    cursor: pointer;
  }

  .action-button-icon {
    font-size: 20px;
    margin-right: 8px;
  }
`;
